import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, Users, Calendar, Shield, ArrowRight } from 'lucide-react';

const Home: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-slate-50 to-blue-50 flex items-center justify-center p-4 sm:p-6">
      {/* Main Container */}
      <div className="w-full max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          
          {/* Left Side - Hero Content */}
          <div className="text-center space-y-6 lg:space-y-8">
            {/* Logo and Brand */}
            <div className="space-y-4 lg:space-y-6">
              <div className="mb-4 lg:mb-6">
                <img 
                  src="/images/LOGO.png" 
                  alt="PlayKids - Contratos" 
                  className="w-32 h-auto sm:w-28 lg:w-32 mx-auto lg:mx-0"
                />
              </div>
              
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 font-display leading-tight">
                Recreação Infantil
              </h1>
              
              <p className="text-base sm:text-lg lg:text-xl text-slate-600 leading-relaxed max-w-lg mx-auto lg:mx-0">
                Contrate nossos serviços para eventos infantis
              </p>
            </div>

            {/* CTA Button */}
            <div className="pt-2 lg:pt-4">
              <Link 
                to="/formulario"
                className="inline-flex items-center justify-center space-x-2 sm:space-x-3 bg-teal-600 hover:bg-teal-700 text-white font-bold text-base sm:text-lg w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 rounded-lg shadow-lg hover:shadow-xl transition-all duration-200"
              >
                <Calendar className="w-4 h-4 sm:w-5 sm:h-5" />
                <span>Contratar</span>
              </Link>
            </div>


          </div>
          
          {/* Right Side - Features Grid */}
          <div className="hidden sm:grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
            {/* Feature Card 1 */}
            <div className="bg-white rounded-lg p-3 sm:p-4 shadow-sm border border-slate-200">
              <div className="w-6 h-6 sm:w-8 sm:h-8 bg-blue-500 rounded-lg flex items-center justify-center mb-2 sm:mb-3">
                <Calendar className="w-3 h-3 sm:w-4 sm:h-4 text-white" />
              </div>
              <h3 className="text-sm sm:text-base font-semibold text-slate-900 mb-1">Orçamento Rápido</h3>
              <p className="text-xs sm:text-sm text-slate-600">Solicite em poucos minutos</p>
            </div>

            {/* Feature Card 2 */}
            <div className="bg-white rounded-lg p-3 sm:p-4 shadow-sm border border-slate-200">
              <div className="w-6 h-6 sm:w-8 sm:h-8 bg-green-500 rounded-lg flex items-center justify-center mb-2 sm:mb-3">
                <Users className="w-3 h-3 sm:w-4 sm:h-4 text-white" />
              </div>
              <h3 className="text-sm sm:text-base font-semibold text-slate-900 mb-1">Recreadores Profissionais</h3>
              <p className="text-xs sm:text-sm text-slate-600">Equipe qualificada</p>
            </div>

            {/* Feature Card 3 */}
            <div className="bg-white rounded-lg p-3 sm:p-4 shadow-sm border border-slate-200">
              <div className="w-6 h-6 sm:w-8 sm:h-8 bg-purple-500 rounded-lg flex items-center justify-center mb-2 sm:mb-3">
                <FileText className="w-3 h-3 sm:w-4 sm:h-4 text-white" />
              </div>
              <h3 className="text-sm sm:text-base font-semibold text-slate-900 mb-1">Contrato Seguro</h3>
              <p className="text-xs sm:text-sm text-slate-600">Documentação completa</p>
            </div>

            {/* Feature Card 4 */}
            <div className="bg-white rounded-lg p-3 sm:p-4 shadow-sm border border-slate-200">
              <div className="w-6 h-6 sm:w-8 sm:h-8 bg-teal-500 rounded-lg flex items-center justify-center mb-2 sm:mb-3">
                <Shield className="w-3 h-3 sm:w-4 sm:h-4 text-white" />
              </div>
              <h3 className="text-sm sm:text-base font-semibold text-slate-900 mb-1">Qualidade Garantida</h3>
              <p className="text-xs sm:text-sm text-slate-600">5+ anos de experiência</p>
            </div>
          </div>
        </div>
        
        {/* Version Info */}
        <div className="text-center mt-12">
          <div className="text-sm text-slate-500">
            <span>Sistema de Contratos v2.0</span>
            <span className="mx-2">•</span>
            <span>PlayKids - Recreação Infantil</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;



